<template>
  <page>
    <template slot="content">
      <help-content :title="'計測データに関してご質問がある場合'">
        <template slot="content">
          <div class="text">
            ヘルプデスク(<a href="mailto:help@werunclub.net">help@werunclub.net</a>)までご連絡ください。
          </div>
        </template>
      </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help11.vue